import {useEffect} from "react";
import {message} from "antd";
import T from "../services/language";
import {useNavigate, useParams} from "react-router-dom";
import {useApp} from "../contexts/app";
import Environment from "../environment";

export default function useSessionCompleted() {
    let {
        campaignPath,
        campaignId,
        customerId,
        productServiceId,
        productServiceType,
        quantity,
        packageIndex, postalCode, locationType
    }: any = useParams();
    const navigate = useNavigate();
    const {addAnswered, getAnswered, getLocalProductService, clientCode} = useApp();

    useEffect(() => {
        try {
            if (!Environment.canBackSupport) {
                if (getSessionDone(campaignId, customerId)) {
                    message.error(T("You have completed the booking process"));
                    navigate(`/${clientCode}/${campaignPath}`, {replace: true});
                }
            }
        } catch (e) {
            console.error(e);
        }
    }, []);

    return {
        set: () => setSessionDone(campaignId, customerId),
    }
}


const setSessionDone = (campaignId, customerId) => {
    window.sessionStorage.setItem(`session-done-${campaignId}-${customerId}`, "true");
}

const getSessionDone = (campaignId, customerId) => {
    return !!window.sessionStorage.getItem(`session-done-${campaignId}-${customerId}`);
}